import { render, staticRenderFns } from "./ComplainListFilter.vue?vue&type=template&id=2e6aff14&scoped=true&"
import script from "./ComplainListFilter.vue?vue&type=script&lang=js&"
export * from "./ComplainListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6aff14",
  null
  
)

export default component.exports